import React, { Component } from 'react';
import { Paper } from 'material-ui';
import { Steppers } from '../components/createEditPush';

class Messages extends Component {

  render() {
    return (
      <div style={styles.container}>
        <h3>Create Notification</h3>
        <Paper style={styles.container}>
          <Steppers {...this.props} />
        </Paper>
      </div>
    );
  }
}

export default Messages;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
  }
}


// WEBPACK FOOTER //
// ./src/pages/EditPush.js